import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
import List from '@/views/HubManagement/HubList/List.vue';
import SubController from '@/views/HubManagement/HubList/SubController.vue';
import { computed, onMounted, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRouter } from 'vue-router';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const router = useRouter();
        const isDistUser = computed(() => vuexStore.getters['user/isDistUser']);
        const permission = computed(() => vuexStore.getters['user/isPermissionOtherHub']);
        const hubId = computed(() => vuexStore.getters['user/hubId']);
        onMounted(() => {
            // 총판계정과 타허브 권한 있는 계정만 접근할 수 있다. 아니면 바로 본인 허브로 리다이렉트
            if (!isDistUser.value
                || !permission.value) {
                router.replace({
                    name: routeName.HUB_MANAGEMENT_DETAIL,
                    params: {
                        hubId: hubId.value,
                    },
                });
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createVNode(List)
            ]));
        };
    }
});
